{
	"$generatedFrom": "https://en.wiktionary.org/wiki/Wiktionary:Frequency_lists/Contemporary_fiction_in_60_categories",
	"color": [
		"black",
		"white",
		"blue",
		"red",
		"green",
		"clear",
		"brown",
		"pink",
		"grey",
		"pale",
		"yellow",
		"orange",
		"silver",
		"purple",
		"gold",
		"tan",
		"golden"
	],
	"anatomy": [
		"back",
		"eye",
		"hand",
		"head",
		"face",
		"arm",
		"hair",
		"shoulder",
		"body",
		"mouth",
		"lip",
		"feet",
		"finger",
		"heart",
		"leg",
		"ear",
		"chest",
		"cheek",
		"neck",
		"stomach",
		"skin",
		"eyebrow",
		"nose",
		"foot",
		"throat",
		"knee",
		"bottom",
		"buttock",
		"teeth",
		"brain",
		"tongue",
		"forehead",
		"lap",
		"waist",
		"wrist",
		"chin",
		"jaw",
		"hip",
		"heel",
		"brow",
		"palm",
		"muscle",
		"wing",
		"elbow",
		"nail",
		"tail",
		"toe",
		"nerve",
		"bone",
		"thumb",
		"breast",
		"thigh",
		"gut",
		"abdomen"
	],
	"cognition": [
		"thought",
		"mind",
		"idea",
		"sleep",
		"know",
		"think",
		"remember",
		"forget",
		"realize",
		"believe",
		"wonder",
		"attention",
		"asleep",
		"wake",
		"suppose",
		"understand",
		"dream",
		"figure",
		"consider",
		"learn",
		"forget",
		"familiar",
		"memory",
		"experience",
		"emotion",
		"awake",
		"remind",
		"trust",
		"imagine",
		"recognize",
		"focus",
		"assume",
		"gather",
		"image",
		"information",
		"lesson",
		"blame",
		"judge",
		"lost",
		"mental",
		"opinion",
		"nightmare",
		"puzzle",
		"confuse",
		"suspect",
		"recall",
		"concentrate"
	]
}
